const SPEED_PX_PER_SEC = 34;
const START_DELAY_MS = 2000;
const RESUME_DELAY_MS = 1200;
const JUMP_YIELD_MS = 900;
const VISIBLE_ENOUGH = 0.3;
const ARROW_TILES = 2;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initMarquee(root) {
  const track = root.querySelector('[data-hd-scroller-track]');
  if (!(track instanceof HTMLElement)) return;

  if (track.dataset.hdMarquee === 'on') return;
  if (track.scrollWidth <= track.clientWidth + 4) return;

  const originals = Array.from(track.children);
  if (originals.length < 2) return;

  originals.forEach((node) => {
    const clone = node.cloneNode(true);
    if (clone instanceof HTMLElement) {
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.hdMarqueeClone = '1';
      clone.querySelectorAll('a, button, input, [tabindex]').forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });
    }
    track.appendChild(clone);
  });

  track.dataset.hdMarquee = 'on';
  track.classList.add('hd-marquee-on');

  root.dataset.hdScrollerStep = String(ARROW_TILES);

  const firstClone = track.querySelector('[data-hd-marquee-clone]');

  let period = 0;
  const measure = () => {
    period =
      firstClone instanceof HTMLElement
        ? firstClone.getBoundingClientRect().left - originals[0].getBoundingClientRect().left
        : 0;
  };

  measure();
  if ('ResizeObserver' in window) {
    new ResizeObserver(measure).observe(track);
  } else {
    window.addEventListener('resize', measure);
  }

  let paused = false;
  let resumeTimer = null;
  let last = 0;

  let position = track.scrollLeft;
  let expected = track.scrollLeft;
  let yieldUntil = 0;

  let armed = false;
  let armTimer = null;

  const arm = () => {
    if (armed || armTimer) return;
    armTimer = window.setTimeout(() => {
      armed = true;
      armTimer = null;

      position = track.scrollLeft;
      expected = track.scrollLeft;
      track.dataset.hdMarqueeState = 'running';
    }, START_DELAY_MS);
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            arm();
            io.disconnect();
          }
        });
      },
      { threshold: VISIBLE_ENOUGH }
    );
    io.observe(root);
  } else {
    arm();
  }

  track.dataset.hdMarqueeState = 'waiting';

  const pause = () => {
    paused = true;
  };

  const resume = () => {
    paused = false;
  };

  const pauseBriefly = () => {
    paused = true;
    if (resumeTimer) window.clearTimeout(resumeTimer);
    resumeTimer = window.setTimeout(() => {
      paused = false;
      resumeTimer = null;
    }, RESUME_DELAY_MS);
  };

  const frame = (now) => {
    if (!last) last = now;
    const dt = Math.min(now - last, 100) / 1000;
    last = now;

    const yielding = now < yieldUntil;

    if (armed && !yielding && !paused && !document.hidden && !reduceMotion.matches && period > 0) {
      position += SPEED_PX_PER_SEC * dt;
      if (position >= period) position -= period;
      track.scrollLeft = position;
      expected = track.scrollLeft;
    }

    window.requestAnimationFrame(frame);
  };

  root.addEventListener('hd-scroller:jump', (e) => {
    const left = e.detail && typeof e.detail.left === 'number' ? e.detail.left : 0;
    if (period > 0) {
      const max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft + left < 0) track.scrollLeft += period;
      else if (track.scrollLeft + left > max) track.scrollLeft -= period;
    }
    yieldUntil = performance.now() + JUMP_YIELD_MS;
  });

  track.addEventListener(
    'scroll',
    () => {
      if (Math.abs(track.scrollLeft - expected) > 2) {
        position = period > 0 ? track.scrollLeft % period : track.scrollLeft;
        expected = track.scrollLeft;
      }
    },
    { passive: true }
  );

  root.addEventListener('pointerenter', pause);
  root.addEventListener('pointerleave', resume);
  root.addEventListener('focusin', pause);
  root.addEventListener('focusout', (e) => {
    if (!(e.relatedTarget instanceof Node) || !root.contains(e.relatedTarget)) resume();
  });

  track.addEventListener('pointerdown', pause);
  window.addEventListener('pointerup', resume);
  track.addEventListener('touchstart', pause, { passive: true });
  track.addEventListener('touchend', pauseBriefly, { passive: true });
  track.addEventListener('wheel', pauseBriefly, { passive: true });

  window.requestAnimationFrame(frame);
}

function boot() {
  document.querySelectorAll('.shop-by-brand [data-hd-scroller]').forEach((el) => {
    if (el instanceof HTMLElement) initMarquee(el);
  });
}

if (document.readyState === 'complete') {
  boot();
} else {
  window.addEventListener('load', boot);
}
